const siteUrl = 'https://www.maseratioffers.com/'

module.exports = {
  /* Your site config here */
  siteMetadata: {
    title: 'Findlay',
    siteUrl:'https://www.maseratioffers.com/',
    site_id: '675b570ef3725edbc2b59fa9',
    api_base_url: 'https://api.dealermasters.com:4500',
    lead_url: 'https://leads.dealermasters.com/leads/validated',
    distance_history: 'https://aalnfl2zj7.execute-api.us-east-2.amazonaws.com/Prod', //Distance history API Gateway AWS
    googleAPIkey: 'AIzaSyCddq6ehnmTvcAdFOvG5xEGhn8jZV3eBqY',
    quickgenAPI: 'https://dev.mxsapi.com',
    imageBaseURL: 'https://images.mxssolutions.com', //PROD: 'https://images.mxssolutions.com'
    opensearchAPI: 'https://tehy4uupcb.execute-api.us-east-2.amazonaws.com/opensearch-inventory-search-api/'// DEV: 'https://q0mj4jv9i6.execute-api.us-east-2.amazonaws.com/opensearch-inventory-search-api/'
  },
  plugins: [
    'gatsby-plugin-react-helmet',
    {
      resolve: "gatsby-plugin-force-trailing-slashes"
    },
    {
      resolve: 'gatsby-plugin-advanced-sitemap',
      options: {
      },
    },
    {
      resolve: "gatsby-plugin-emotion"
    },
    {
      resolve: "gatsby-transformer-json"
    },
    {
      resolve: "gatsby-plugin-sass",
      options: {
        cssLoaderOptions: {
          camelCase: false,
        },
      },
    },
    {
      resolve: "gatsby-plugin-react-svg",
      options: {
        rule: {
          include: /\.inline\.svg$/
        }
      }
    },
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `src`,
        path: `${__dirname}/src/`
      }
    },
    {
      resolve: 'gatsby-plugin-s3',
      options: {
        bucketName: 'mxs-1bce6843-4a9d-40f5-8ae1-0c2653f9b514-prodsite'
      }
    },
    `gatsby-transformer-json`,
    {
      resolve: require.resolve('./plugins/gatsby-source-dynamodb-query'),
      options: {
        typeName: 'inventory',
        region: 'us-east-2',
        tableName: 'AdjustedInventory',
        dealerId: ['627372841']//126024
      }
    },
    {
      resolve: 'gatsby-plugin-manifest',
      options: {
        icon: 'static/favicon.png'
      }
    },{
      resolve: 'gatsby-plugin-robots-txt',
      options: {
        host: 'https://www.maseratioffers.com/',
        sitemap: 'https://www.maseratioffers.com//sitemap-pages.xml',
        policy: [{ userAgent: '*', allow: '/' }]
      }
    }
  ]
}
